const CHAT_SESSION_KEY = "chat_widget_session_id";
const CHAT_USER_KEY = "chat_widget_user_id";

const generateId = (prefix: string): string => {
  if (typeof crypto !== "undefined" && typeof crypto.randomUUID === "function") {
    return `${prefix}-${crypto.randomUUID()}`;
  }
  return `${prefix}-${Date.now()}-${Math.random().toString(36).slice(2, 10)}`;
};

export const getOrCreateChatIdentity = (): { sessionId: string; userId: string } => {
  const existingSessionId = localStorage.getItem(CHAT_SESSION_KEY);
  const existingUserId = localStorage.getItem(CHAT_USER_KEY);

  if (existingSessionId && existingUserId) {
    return { sessionId: existingSessionId, userId: existingUserId };
  }

  const sessionId = existingSessionId || generateId("session");
  const userId = existingUserId || generateId("user");

  localStorage.setItem(CHAT_SESSION_KEY, sessionId);
  localStorage.setItem(CHAT_USER_KEY, userId);

  return { sessionId, userId };
};
